// extracted by mini-css-extract-plugin
module.exports = {"group":"c01r0xX87dTH","item":"h2RpYJLeb3MS","label":"_182cbkyZgJhD","value":"SRm0P4FlIjj6"};